module.exports = __webpack_public_path__ + "static/media/sebastian.f78127eb.png";